import { FC, useEffect, useMemo } from 'react';

import { PageName } from '../../types/Analytics';
import { StaticPage } from '../../types/StaticContentType';
import { TrackPageView } from '../../utils/analytics';
import { useAnalyticsEmitter } from '../../utils/analytics/emitter';
import { StaticSections } from '../Static';
import { StaticHero } from '../Static/StaticHero';

interface Props {
  page: StaticPage;
  pageName: PageName;
}

export const Static: FC<Props> = ({ page, pageName }) => {
  useEffect(() => {
    TrackPageView({ page: pageName });
  }, [pageName]);

  const properties = useMemo(
    () => ({
      context: `${pageName} page`,
      page: pageName,
    }),
    [pageName],
  );

  const [analyticsEmitter] = useAnalyticsEmitter(properties);

  return (
    <main className="my-9 space-y-9 md:my-12 md:space-y-12">
      <StaticHero
        reorder={page.content.introReorder}
        sections={page.content.intro || []}
      />
      <StaticSections
        sections={page.content.sections || []}
        track={analyticsEmitter}
      />
    </main>
  );
};
